import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToTexasMargariasInCarmel from "./sections/WelcomeToTexasMargariasInCarmel";
import FeaturedMenuHighlights from "./sections/FeaturedMenuHighlights";
import CallToActionReserveOrOrder from "./sections/CallToActionReserveOrOrder";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeToTexasMargariasInCarmel />
      <FeaturedMenuHighlights />
      <CallToActionReserveOrOrder />
      <Footer />
    </div>;
}